<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (project) {
    <div [config]="preloaderService.getLoadingConfig(loaderKey)" [suiIsLoading]="loaderKey" class="preloader-wrapper">
        <form (ngSubmit)="confirmClone(project.id)" class="dialog-form dialog-max-height-xxl" name="cloneForm">
            <div class="siklu-mat-dialog-title" matDialogTitle>
                <h4>
                    {{ (projectStateService.isPotentiallyCorruptedProject() ? 'entity.migrate.title' : 'entity.clone.title') | translate }}
                </h4>
                <button matDialogClose windeClose>
                    <sui-svg-icon icon="cross" />
                </button>
            </div>
            <div class="siklu-mat-dialog-body no-scroll" matDialogContent>
                <winde-alert-error></winde-alert-error>
                @if (projectStateService.isPotentiallyCorruptedProject()) {
                    <div class="alert alert-warning">
                        <span>WiNDE will try to migrate this project automatically</span>
                    </div>
                }
                <winde-validation-alert
                    [(showAlert)]="showFormValidationAlert"
                    [messageObservable]="alertMessageSubject.asObservable()"
                ></winde-validation-alert>
                <p class="form-group">
                    <span
                        [innerHTML]="'entity.clone.question' | translate: { name: project.name | gtthTextEscape }"
                        class="form-control-label ellipsis-span"
                    >
                        {{ projectStateService.isPotentiallyCorruptedProject() ? 'entity.migrate.title' : 'entity.clone.title' }}
                    </span>
                    <input
                        [(inputVal)]="newName"
                        [(ngModel)]="newName"
                        [cutPattern]="'[^a-z\\d\\s\#@!;\$\&\%\(\)_\+=\.\,\~\\-\{\}\\[\\]\\^\'`]'"
                        [showValidationText]="showFormValidationAlert"
                        class="form-control"
                        id="new_name"
                        name="new_name"
                        required
                        type="text"
                        windeEntityNameValidation
                    />
                </p>
                <div class="form-group form-check">
                    <input
                        [(ngModel)]="hasToRedirect"
                        [ngModelOptions]="{ standalone: true }"
                        class="form-check-input"
                        id="hasToRedirect"
                        type="checkbox"
                    />
                    <span class="form-check-label" for="hasToRedirect"> Open after save </span>
                </div>
                <div class="form-group">
                    <span class="form-label">Clone to folder:</span>
                    <div class="folders-tree custom-scroll-bar">
                        <winde-folders-tree></winde-folders-tree>
                    </div>
                </div>
            </div>
            <div class="siklu-mat-dialog-footer" matDialogActions>
                <button matDialogClose windeTransparent>
                    <sui-svg-icon icon="cross" />
                    {{ 'entity.action.cancel' | translate }}
                </button>
                <button type="submit" windeGreen>
                    <sui-svg-icon icon="save" />
                    {{
                        (projectStateService.isPotentiallyCorruptedProject() ? 'entity.migrate.submit' : 'entity.clone.submit') | translate
                    }}
                </button>
            </div>
        </form>
    </div>
}
